import { FuturesMarginType } from '@kwenta/sdk/types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Button from 'components/Button'
import { FlexDivCentered } from 'components/layout/flex'
import { Heading } from 'components/Text'
import { CROSS_MARGIN_TARGET_NETWORK } from 'constants/defaults'
import useNetworkSwitcher from 'hooks/useNetworkSwitcher'
import { selectFuturesType } from 'state/futures/common/selectors'
import { useAppSelector } from 'state/hooks'

const FuturesUnsupportedNetwork = () => {
	const accountType = useAppSelector(selectFuturesType)
	const { t } = useTranslation()
	const { switchToL2 } = useNetworkSwitcher(
		accountType === FuturesMarginType.CROSS_MARGIN ? CROSS_MARGIN_TARGET_NETWORK : 10
	)

	const buttonLabel = t(
		'homepage.l2.cta-buttons.switch-l2' +
			(accountType === FuturesMarginType.SMART_MARGIN ? '' : '-testnet')
	)

	return (
		<MessageContainer>
			<Heading variant="h2">{t('futures.page-title')}</Heading>
			<ButtonContainer>
				<Button variant="yellow" onClick={switchToL2}>
					{buttonLabel}
				</Button>
			</ButtonContainer>
		</MessageContainer>
	)
}

const ButtonContainer = styled(FlexDivCentered)`
	width: 100%;
	justify-content: center;
	margin-top: 15px;
`

const MessageContainer = styled.div`
	padding: 20px;
	text-align: center;
	color: ${(props) => props.theme.colors.selectedTheme.gray};
`

export default FuturesUnsupportedNetwork
